import { FC, PropsWithChildren } from 'react';

import { useAtomValue } from 'jotai';

import { useActivity } from '@queries';
import { activityAtom, comparisonSwingAtom } from '@store';

/**
 * Component that flips comparison if handedness does not match.
 */
export const ComparisonMirroring: FC<PropsWithChildren> = ({ children }) => {
    const comparisonSwing = useAtomValue(comparisonSwingAtom);
    const activity = useAtomValue(activityAtom);
    const { data: comparisonActivity } = useActivity(comparisonSwing?.activityId ?? -1);
    if (!activity || !comparisonActivity) {
        return null;
    }
    return <group scale={[activity?.leftHanded !== comparisonActivity?.leftHanded ? -1 : 1, 1, 1]}>{children}</group>;
};
